<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-auto font-prompt">

  <!-- 1. Header (Dark Gradient VIP Theme) -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-6 pb-6 rounded-b-[2.5rem] shadow-lg z-20 shrink-0 text-white border-b border-white/5">
    <div class="flex justify-between items-center px-6 mb-2 select-none">
      <div class="flex items-center gap-3">
        <button
          class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
          (click)="goback()">
          <img src="icons/arrow_back_black.svg" class="w-full h-full" alt="back" />
        </button>
        <h1 class="text-white text-base font-black tracking-wide leading-none">
          {{ currentLang === "TH" ? "สถานีชาร์จ EV" : "EV Charger" }}
        </h1>
      </div>

      <button (click)="getInfoEvChargerByJobId()"
        class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex items-center justify-center active:scale-95 transition-all border border-slate-200/10 outline-none">
        <img src="icons/sync_black_soft.svg" alt="refresh" />
      </button>
    </div>
  </div>

  <!-- 2. Duration + Logo (วงกลมหมุน/แสงตอนชาร์จ — ไม่มีกรอบเหลี่ยม) -->
  <div class="px-6 z-30 flex flex-col items-center" [ngClass]="isConnect ? '-mt-4' : 'mt-5'">
    <div *ngIf="isConnect"
      class="bg-white rounded-2xl shadow-sm border border-slate-100 px-5 py-3 text-center w-full mb-3">
      <p class="text-amber-600 text-lg font-black leading-none">
        {{ displayHours ?? '--' }}
        {{ currentLang === "TH" ? "ชั่วโมง" : "hr" }}
        {{ displayMinutes ?? '--' }}
        {{ currentLang === "TH" ? "นาที" : "min" }}
      </p>
      <p class="text-[10px] text-slate-400 font-bold mt-1.5">
        {{ currentLang === "TH" ? "ระยะเวลาการชาร์จ" : "Charging Duration" }}
      </p>
    </div>

    <div class="relative w-[170px] h-[170px] flex justify-center items-center my-6 bg-white rounded-full shadow-sm">
      <!-- วงหมุนตอนชาร์จ -->
      <div
        class="absolute w-[190px] h-[190px] rounded-full border-8 border-transparent border-t-amber-400 border-r-amber-400 animate-spin-slow blur-[0.5px]"
        *ngIf="isCharging"></div>
      <!-- วงแสงตอนชาร์จ -->
      <div class="absolute w-[200px] h-[200px] rounded-full border-2 border-amber-400/50 animate-glow"
        *ngIf="isCharging"></div>
      <!-- วงนิ่งตอนยังไม่ชาร์จ -->
      <div class="absolute w-[190px] h-[190px] rounded-full border border-slate-100" *ngIf="!isCharging"></div>

      <div class="flex flex-col items-center z-10 relative">
        <img src="images/Ev-car.png" alt="ev-charger" class="w-28 h-28 object-contain mb-1"
          [class.animate-spin-image]="isCharging" />
        <span class="text-[11px] font-black px-2.5 py-0.5 rounded-full"
          [ngClass]="isCharging ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-500'">
          {{
          isCharging
          ? (currentLang === "TH" ? "กำลังชาร์จ" : "Charging")
          : (currentLang === "TH" ? "ยังไม่ชาร์จ" : "Not Charging")
          }}
        </span>
      </div>
    </div>
  </div>

  <!-- 3. Stats Cards -->
  <div class="px-6 mt-3 space-y-3 pb-28">
    <p *ngIf="!isConnect" class="text-[10px] text-rose-500 font-bold text-center leading-snug px-2">
      *{{ currentLang === "TH"
      ? "กรุณาตรวจสอบที่เครื่องว่าการชาร์จเริ่มทำงานแล้วก่อนเดินออกจากจุดชาร์จ"
      : "Please make sure the charger has started charging before leaving." }}*
    </p>

    <div class="grid grid-cols-2 gap-3">
      <div class="bg-(--main-color) rounded-3xl p-4 shadow-sm border border-slate-100 flex flex-col items-center gap-2">
        <div class="w-10 h-10 bg-white rounded-2xl flex items-center justify-center border border-amber-100">
          <img src="/icons/tunder-orange.png" alt="lightning" class="w-5 h-5 object-contain" />
        </div>
        <p class="text-[10px] text-slate-800 font-bold">
          {{ currentLang === "TH" ? "จำนวนไฟฟ้า" : "Energy" }}
        </p>
        <p class="text-sm font-black text-amber-800 leading-none">
          {{ evChargerHistoryInfo?.evChargingJob?.chargingKwh || "-" }}
          <span class="text-[10px] text-slate-800 font-bold">kWh</span>
        </p>
      </div>

      <div class="bg-(--main-color) rounded-3xl p-4 shadow-sm border border-slate-100 flex flex-col items-center gap-2">
        <div class="w-10 h-10 bg-white rounded-2xl flex items-center justify-center border border-amber-100">
          <img src="/icons/coin-orange.png" alt="coins" class="w-5 h-5 object-contain" />
        </div>
        <p class="text-[10px] text-slate-800 font-bold">
          {{ currentLang === "TH" ? "จำนวนเงิน" : "Amount" }}
        </p>
        <p class="text-sm font-black text-amber-800 leading-none">
          {{ evChargerHistoryInfo?.evChargingJob?.chargingAmount || "-" }}
          <span class="text-[10px] text-slate-800 font-bold">THB</span>
        </p>
      </div>
    </div>

    <!-- Notice popup -->
    <div class="relative" *ngIf="showPopupNotice">
      <div
        class="flex items-center gap-2 bg-amber-400 text-slate-800 p-2.5 rounded-2xl shadow-sm animation-slide-up-popup">
        <img src="/icons/alert_comment.png" alt="alert" class="w-4 h-4 object-cover" />
        <span class="text-[11px] font-bold">
          {{ currentLang === "TH"
          ? "คลิกจำนวนไฟฟ้าเพื่อแสดงจำนวนคำนวณไฟฟ้า"
          : "You can click to show energy details" }}
        </span>
      </div>
    </div>

    <!-- Detail list -->
    <div class="bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden">
      <div class="flex items-center justify-between border-b border-slate-50 px-4 py-3">
        <p class="text-[11px] text-slate-400 font-bold w-[40%]">
          {{ currentLang === "TH" ? "สถานีชาร์จ EV" : "Station" }}
        </p>
        <p class="text-[12px] text-slate-700 font-black text-end w-full">
          {{ evChargerHistoryInfo?.siteName || "-" }}
          <span *ngIf="evChargerHistoryInfo?.siteName" class="text-slate-400 font-bold">
            ({{ evChargerHistoryInfo?.spaceCode }})
          </span>
        </p>
      </div>
      <div class="flex items-center justify-between border-b border-slate-50 px-4 py-3">
        <p class="text-[11px] text-slate-400 font-bold w-[40%]">
          {{ currentLang === "TH" ? "เวลาชาร์จ" : "Start Time" }}
        </p>
        <p class="text-[12px] text-slate-700 font-black text-end w-full font-mono">
          {{ (evChargerHistoryInfoJob?.chargingStart | date : "dd/MM/yyyy HH:mm") || "-" }}
        </p>
      </div>
      <div class="flex items-center justify-between px-4 py-3">
        <p class="text-[11px] text-slate-400 font-bold w-[40%]">
          {{ currentLang === "TH" ? "หมายเลขชาร์จ" : "Job ID" }}
        </p>
        <p class="text-[11px] text-slate-700 font-black text-end w-full break-all">
          {{ evChargerHistoryInfoJob?.jobId || "-" }}
        </p>
      </div>
    </div>

    <!-- Slide to start/stop -->
    <div class="pt-2 pb-4 flex items-center justify-center">
      <div #sliderContainer class="relative w-full max-w-sm h-12 rounded-full overflow-hidden shadow-inner" [ngClass]="{
          'bg-white': isConnect && !isCharging,
          ' select-none': isConnect && isCharging,
          'bg-rose-50 select-none border border-rose-100': !isConnect
        }">
        <div #sliderProgress class="absolute left-0 top-0 h-full transition-all" [style.width.%]="progress" [ngClass]="{
            'bg-amber-200/50': isConnect,
            'bg-white': !isConnect
          }"></div>

        <span class="absolute inset-0 flex items-center justify-center text-xs font-black pointer-events-none z-[1]"
          [ngClass]="{
            'text-rose-600': isConnect && !isCharging,
            'text-amber-800': isConnect && isCharging,
            'text-rose-500': !isConnect
          }">
          {{ statusText }}
        </span>

        <div #sliderHandle
          class="absolute top-0 w-12 h-12 p-2 rounded-full flex items-center justify-center cursor-pointer z-[2]"
          [style.left.px]="handleLeft" [ngClass]="{ 'bg-white shadow-md': isConnect }"
          (mousedown)="isConnect ? startDrag($event) : null" (touchstart)="isConnect ? startDrag($event) : null">
          <img *ngIf="!isOpenCharging && isConnect" src="icons/power_settings_new_red.svg" alt="shutdown" />
          <img *ngIf="isOpenCharging && isConnect" src="icons/tunder-orange.png" alt="lightning" />
        </div>
      </div>
    </div>

    <!-- Warnings -->
    <div class="bg-amber-500/[0.04] border border-amber-100 rounded-2xl px-3.5 py-3 text-center space-y-1.5">
      <p class="text-[10px] text-slate-500 font-bold leading-snug">
        {{ currentLang === "TH"
        ? "สถานีอยู่ภายใต้การควบคุมการจ่ายกำลังไฟฟ้า (Low Priority)
        ผู้ใช้บริการอาจได้รับกำลังไฟฟ้าไม่เต็มประสิทธิภาพในบางช่วงเวลา"
        : "The station is under low priority power control, which may affect power supply during peak hours." }}
      </p>
      <p class="text-[11px] text-amber-600 font-black">
        {{ currentLang === "TH" ? "อัตราค่าบริการ : " : "Rate : " }}
        {{ evChargerHistoryInfo?.fee || "-" }}
        {{ currentLang === "TH" ? " บาท/ชั่วโมง" : " THB/hour" }}
      </p>
      <p class="text-[10px] text-rose-500 font-bold leading-snug">
        {{ currentLang === "TH"
        ? "*หากสถานะเลื่อนเพื่อเริ่มชาร์จไม่ขึ้น ให้ถอดแล้วเสียบหัวชาร์จใหม่อีกรอบ"
        : "*If charging does not start, disconnect and reconnect the charger." }}
      </p>
    </div>


  </div>
</div>

<!-- Electric detail modal -->
<div class="fixed inset-0 z-[100] flex justify-center items-center bg-black/50 backdrop-blur-sm p-4"
  *ngIf="showModalEclectic">
  <div class="w-full max-w-sm bg-white rounded-3xl shadow-xl relative animation-slide-up overflow-hidden">
    <div class="flex justify-center items-center h-12 border-b border-slate-100 px-4">
      <p class="text-slate-800 text-sm font-black">
        {{ currentLang === "TH" ? "รายละเอียดคำนวณไฟฟ้า" : "Energy Details" }}
      </p>
      <button
        class="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center outline-none"
        (click)="showModalEclectic = false">
        <img src="icons/close.png" alt="close" class="w-4 h-4 object-cover" />
      </button>
    </div>
    <div class="grid grid-cols-3 gap-3 p-4">
      <div
        class="bg-amber-50 border border-amber-100 rounded-2xl h-[100px] flex flex-col items-center justify-center gap-1">
        <p class="text-amber-600 text-sm font-black">{{ eclecticDetail.voltage }}V</p>
        <p class="text-slate-500 text-[10px] font-bold">
          {{ currentLang === "TH" ? "แรงดัน" : "Voltage" }}
        </p>
      </div>
      <div
        class="bg-amber-50 border border-amber-100 rounded-2xl h-[100px] flex flex-col items-center justify-center gap-1">
        <p class="text-amber-600 text-sm font-black">{{ eclecticDetail.power | number : "1.2-2" }}W</p>
        <p class="text-slate-500 text-[10px] font-bold">
          {{ currentLang === "TH" ? "กำลัง" : "Power" }}
        </p>
      </div>
      <div
        class="bg-amber-50 border border-amber-100 rounded-2xl h-[100px] flex flex-col items-center justify-center gap-1">
        <p class="text-amber-600 text-sm font-black">{{ eclecticDetail.current }}A</p>
        <p class="text-slate-500 text-[10px] font-bold">
          {{ currentLang === "TH" ? "กระแส" : "Current" }}
        </p>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
<app-pss-warn *ngIf="isWarning" [text]="textWarn" [detail]="detailWarn"
  [imageSrc]="warnImageSrc" (close)="isWarning = false"></app-pss-warn>
